import axiosInstance from "../helpers/axiosInstance"

export const getBillingSummary = async function (params) {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-billing-services/billing-summary`, {params: params})
    return res.data
}
